import HomePage from 'components/templates/HomeTemplate/HomeTemplate'

export default HomePage
